module.exports = __webpack_public_path__ + "static/img/pile-num.f986eba5.png";